import React, {Component} from "react";
import DateFormat from "../../common/format/DateFormat";
import {Icon} from "antd";
import {injectIntl} from "react-intl";
import DateUtil from "../../../services/DateUtil";
import Picture from "../picture/Picture";
import Document from "../attachments/Document";

class Message extends Component {

  renderText = (message)=>{
    if (!message.message || message.url){
      return;
    }
    const text = message.message;
    return text.split('\n').map((item, index) => {
      return <span key={index}>{item}<br/></span>
    })
  };

  renderFile = (message)=>{
    if (!message.file){
      return;
    }
    const file = message.file;
    if (file.mimeType && file.mimeType.startsWith('image/')) {
      return <Picture picture={file}/>
    } else {
      return <Document document={file}/>
    }
  };

  renderUrl = (message)=>{
    if (!message.url){
      return;
    }
    const url = message.url + '&preview=true';
    return <a href={url} target="_blank">{url}</a>
  };


  render() {
    const {intl:{formatMessage}, message} = this.props;
    const mineClassName = message.internal === true ? 'message--mine' : '';

    let readIcon = null;
    if (message.internal && message.read){    // icon is only for advisor messages
        readIcon = <Icon type="check-circle" style={{fontSize: '12px', paddingLeft: '5px'}} fill="green" title={formatMessage({id:'read.acknowledge'}, {readAt:DateUtil.formatDate(message.readAt)})}/>
    }
    return (
            <li className={`message ${mineClassName}`}>
              <blockquote className="message__content">
                {this.renderText(message)}
                {this.renderFile(message)}
                {this.renderUrl(message)}
              </blockquote>
              <cite className="message__metas">
                <strong>{message.from}</strong>
                - <DateFormat className="ml-1" layout={"dateTimeLong"} date={message.sentAt}/>
                {readIcon}
              </cite>
            </li>
    )
  }
}

export default injectIntl(Message)



// WEBPACK FOOTER //
// ./src/components/interventiondetail/conversation/Message.js